import { useTranslation } from 'next-i18next/pages';
import { ImageProps } from 'next/image';
import React from 'react';

import { useFlavorFromRoute } from '@pflegia/ui/hooks/use-flavor-from-route';

import BaseEmployeeHeader from '../base/EmployeeHeader.component';

interface EmployeeHeaderProps {
  className?: string;
  image?: ImageProps['src'];
  imageClassName?: string;
  name?: string;
  nameClassName?: string;
  subtitle?: string;
}

export const EmployeeHeader: React.FC<EmployeeHeaderProps> = ({
  className,
  imageClassName,
  image = '/assets/no-contact-person.png',
  name,
  nameClassName,
  subtitle,
}) => {
  const { t } = useTranslation('funnel', { keyPrefix: 'employee' });
  const { isPraxia } = useFlavorFromRoute();
  const fallbackSubtitle = t(isPraxia ? 'praxia.subtitle' : 'subtitle');

  return (
    <BaseEmployeeHeader
      className={className}
      image={image}
      imageClassName={imageClassName}
      name={name || t('name')}
      nameClassName={nameClassName}
      subtitle={subtitle || fallbackSubtitle}
    />
  );
};
